import Swiper, { EffectFade, Autoplay, Navigation } from 'swiper';

class HomeHeroFull {
  constructor(el) {
    this.el = el;
    Swiper.use([Autoplay, EffectFade, Navigation]);

    this.initSlider();
  }
  initSlider() {
    this.swiper = new Swiper(this.el.querySelector('[data-hero-swiper]'), {
      effect: 'fade',
      loop: true,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 6000,
      },
    });
  }
}

export default HomeHeroFull;
